import React from 'react'
import Layout from './Layout';
import { MyInfoComponent } from '../../components/User/MyInfo'

export const MyInfoPage = () => <Layout><MyInfoComponent></MyInfoComponent></Layout>
